
<div class="global-background">

    <!-- First button row -->
    <div class="buttons-row-1">

        <!-- Button - Open Mat menu - Load (DICOM | Project) -->
        <button 
            mat-raised-button         
            color="primary" 
            class="base_buttons full_width button_with_icon"
            [matMenuTriggerFor]="menuLoad"
            >
                {{optionMenu_Load_value}}
                <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
        </button>

        <!-- Button - Open Mat menu - Patient -->
        <button 
            mat-raised-button 
            color="primary" 
            class="base_buttons full_width button_with_icon"
            [matMenuTriggerFor]="menuPatient" 
            [disabled]="(applicationState < 1) || (this.loadedFromProject)"
            >
                {{optionMenu_Patient_value}}
                <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>            
        </button>
        
        <!-- Button - Open Mat menu - Study -->
        <button 
            mat-raised-button 
            color="primary" 
            class="base_buttons full_width button_with_icon"
            [matMenuTriggerFor]="menuStudy" 
            [disabled]="(applicationState < 2) || (this.loadedFromProject)"
            >
                {{optionMenu_Study_value}}
                <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
        </button>

        <!-- Button - Open Mat menu - Series -->
        <button 
            mat-raised-button 
            color="primary" 
            class="base_buttons full_width button_with_icon"
            [matMenuTriggerFor]="menuSeries" 
            [disabled]="(applicationState < 3) || (this.loadedFromProject)"
            >
                {{optionMenu_Series_value}}
                <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
        </button>

        <!-- Button - Open Mat menu - Process -->
        <button 
            mat-raised-button     
            color="primary" 
            class="base_buttons full_width button_with_icon"
            [matMenuTriggerFor]="menuProcess" 
            [disabled]="(applicationState < 4) || (this.loadedFromProject)"
            >
                {{optionMenu_Process_value}}
                <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
        </button>



        <!-- Menu - Load -->
        <mat-menu #menuLoad="matMenu" yPosition="below">
            <button mat-menu-item *ngFor="let item of optionMenu_Load_OptionList; let i=index"
            (click)="optionMenuClick_Load(i)" >
                {{item}}
            </button>
        </mat-menu>

        <!-- Menu - Patient -->
        <mat-menu #menuPatient="matMenu" yPosition="below">
            <button mat-menu-item *ngFor="let item of optionMenu_Patient_OptionList; let i=index" 
            (click)="optionMenuClick_Patient(i)" >
                {{item}}
            </button>
        </mat-menu>

        <!-- Menu - Study -->
        <mat-menu #menuStudy="matMenu" yPosition="below">
            <button mat-menu-item *ngFor="let item of optionMenu_Study_OptionList; let i=index"
            (click)="optionMenuClick_Study(i)" >
                {{item}}
            </button>
        </mat-menu>

        <!-- Menu - Series -->
        <mat-menu #menuSeries="matMenu" yPosition="below">
            <button mat-menu-item *ngFor="let item of optionMenu_Series_OptionList; let i=index"
            (click)="optionMenuClick_Series(i)" >
                {{item}}
            </button>
        </mat-menu>

        <!-- Menu - Process -->
        <mat-menu #menuProcess="matMenu" yPosition="below">
            <button mat-menu-item *ngFor="let item of optionMenu_Process_OptionList; let i=index"
            (click)="optionMenuClick_Process(i)" >
                {{languageService.Strings.processesString[item.key]}}
            </button>
        </mat-menu>        

    </div>




    <!-- Second button row -->
    <div class="buttons-row-2">
        <!-- Button - Data -->
        <button 
            mat-raised-button 
            color="primary"
            class="base_buttons full_width max-buttons-wdith"
            (click)="buttonAction_data()" 
            *ngIf="applicationState >= 5">
                {{languageService.Strings.fnStrings.button_data}}
        </button>
        <!-- Button - Vertebrae artifact ranges -->
        <button 
            mat-raised-button 
            color="primary"
            class="base_buttons full_width max-buttons-wdith"
            (click)="buttonAction_setLines('artifacts')" 
            [disabled]="!(this.additionalInformationDict['artifacts'] === true) || applicationState < 6"
            [class.button_pushed]="button_pushed === 'artifacts'"
            *ngIf="applicationState >= 5"
            >
                {{languageService.Strings.fnStrings.button_artifactsRanges}}
        </button>
        <!-- Button - Vertebrae overflow ranges -->
        <button 
            mat-raised-button 
            color="primary"
            class="base_buttons full_width max-buttons-wdith"
            (click)="buttonAction_setLines('overflow')" 
            [disabled]="!(this.additionalInformationDict['overflow'] === true) || applicationState < 6"
            [class.button_pushed]="button_pushed === 'overflow'"
            *ngIf="applicationState >= 5"
            >
                {{languageService.Strings.fnStrings.button_overflowRanges}}
        </button>
        <!-- Button - Vertebrae levels -->
        <button 
            mat-raised-button 
            color="primary"
            class="base_buttons full_width max-buttons-wdith"
            (click)="buttonAction_setLines('vertebralLevels')" 
            [class.button_pushed]="button_pushed === 'vertebralLevels'"
            [disabled]="applicationState < 6"
            *ngIf="applicationState >= 5"
            >
                {{languageService.Strings.fnStrings.button_vertebralLevels}}
        </button>
        


        <!-- Button - Download Results -->
        <button 
            mat-raised-button 
            color="primary"
            class="base_buttons full_width max-buttons-wdith"
            (click)="buttonAction_results()" 
            [disabled]="!resultsCanBeGenerated()"
            *ngIf="applicationState >= 5"
            >
                {{languageService.Strings.fnStrings.button_zip}}
        </button>

    </div>



    <!-- Images row -->
    <div class="images-row">
       
        <div class="canvas-image" style="position: relative;">
            <canvas 
                #canvasElementLeft 
                class="canvas-image" 
                style="position: absolute; left: 0; top: 0; z-index: 1;">
            </canvas>
            <canvas 
                #canvasElementLeft_TextOverlay 
                class="canvas-image" 
                style="position: absolute; left: 0; top: 0; z-index: 2;">
            </canvas>
        </div>

        <div class="canvas-image" style="position: relative;">
            <canvas 
                #canvasElementRight 
                class="canvas-image" 
                (wheel)="canvasRight_onWheel($event)" 
                (click)="canvasRight_onClick($event)"
                (contextmenu)="canvasRight_onRightClick($event)"
                style="position: absolute; left: 0; top: 0; z-index: 1;">
            </canvas>
            <canvas 
                #canvasElementRight_Overlay 
                class="canvas-image" 
                (wheel)="canvasRight_onWheel($event)" 
                (click)="canvasRight_onClick($event)"
                (contextmenu)="canvasRight_onRightClick($event)"
                style="position: absolute; left: 0; top: 0; z-index: 2;">
            </canvas>
        </div>
          
    </div>

</div>




<!-- Waiting spinner -->
<div *ngIf="(displayWaitingSpiner)" >
    <app-waiting-spinner [waitingMessage]="waitingMessage" ></app-waiting-spinner> 
</div>



<!-- Invisible file inputs -->
<input 
    #fileInput_DICOM
    type="file" 
    webkitdirectory allowdirs msdirectory odirectory directory 
    multiple
    class="file_input"
    (change)="onFileSelected_DICOM($event)"
>
